export default "__VITE_ASSET__BnrurOIk__"